import React from 'react';
import { motion } from 'framer-motion';
export function ProblemBlock() {
  return <section className="w-full bg-white px-5 py-6 sm:py-10" data-id="element-163" data-mp="i31yd4995b3x">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4
    }} className="mx-auto max-w-2xl rounded-2xl border-l-4 border-red-400 bg-[#FFF5F5] p-5 sm:p-8" data-id="element-164" data-mp="i3lbm7nyjbbm">
        <h2 className="font-serif-display text-xl font-bold leading-tight text-ink sm:text-2xl" data-id="element-165" data-mp="3f8h7f4iq0j8">
          Preparare una lezione non dovrebbe significare aprire dieci siti diversi.
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-ink/80 sm:text-base" data-id="element-166" data-mp="3qivdbenxqeiv">
          Cerchi una scheda. Poi una spiegazione più chiara. Poi un'attività. Poi una verifica. Poi
          le soluzioni.
          <br className="hidden sm:block" data-id="element-167" data-mp="1oqgwkix4ng41" /> E alla fine devi ancora controllare, adattare e
          organizzare tutto.
        </p>
        <div className="mt-4 rounded-xl bg-white/60 p-3 sm:mt-5 sm:p-4" data-id="element-168" data-mp="qbf1ofkn9ff2">
          <p className="text-sm font-bold text-red-600 sm:text-base" data-id="element-169" data-mp="qdhybigay6sr">
            Il problema non è trovare materiale online. Il problema è il tempo che perdi per trovare
            quello giusto.
          </p>
        </div>
      </motion.div>
    </section>;
}